export const GET_REGISTRATION_REPORT_EXAM_LEVEL = 'GET_REGISTRATION_REPORT_EXAM_LEVEL';
export const GENERATE_REPORT = 'GENERATE_REPORT';
export const GET_FILE_GENERATE_REPORT = 'GET_FILE_GENERATE_REPORT';

export const GET_NON_NATIONAL_EXAM_LIST = 'GET_NON_NATIONAL_EXAM_LIST';
